import { render, staticRenderFns } from "./ItemSelection.vue?vue&type=template&id=22a8ccbd&scoped=true&"
import script from "./ItemSelection.vue?vue&type=script&lang=ts&"
export * from "./ItemSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSelection.vue?vue&type=style&index=0&id=22a8ccbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8ccbd",
  null
  
)

export default component.exports